<template>
    <div class="container-fluid container_bStore_widget">
        <article :class="['container-bStore_widget', (isModeDark==1) ? 'modeDark' : '']">
            <nav-product-category
                @clickItem="showSection($event)"
                @changeCatActive="changeCatActive($event)"
                @liOffsetWidth="menuLiOffsetWidth($event)"
                :listCat="listCat"
                :menuCatActivo="categoryActive"
                v-if="listCat.length>0"
            ></nav-product-category>
            <product-list-widget
                v-if="listCat.length>0"
                @followItem="indicadorMenu($event)"
                :urlMedia="urlMedia+path_base"
                :listCat="listCat"
                :getCurrency="currency"
                :menuCatActivo="categoryActive"
                :sectionActive="sectionActive"
            ></product-list-widget>
        </article>
    </div>
</template>
<script>
import "./stylesGlobal.scss"
import nav_bStore_widget from "./components/nav_bStore.vue"
import productList_widget from "./components/productList.vue"
export default {
    props: ['modeDark'],
    components:{
        'nav-product-category': nav_bStore_widget,
        'product-list-widget': productList_widget,
    },
    data(){
        return {
            isLoading: false,
            apiProgess: 0,
            listCat: [],
            categoryActive: null,
            apis: null,
            pagRows: 0,
            searchCategory: null,
            filter_status: [1],
            ordenKey: 'orden',
            ordenVal: 'ASC',
            filter_group: [],
            urlMedia: null,
            path_base: null,
            isModeDark: null,
            currency: null,
            sectionActive: null,
        };
    },
    created(){
        let t = this;
        t.isModeDark = t.modeDark;
        let urlApis = t.$store.getters['ModApps/Marketea/urlApis'];
        t.apis = urlApis.bStore;
        t.getList();
    },
    watch: {
        modeDark(){
            let t = this;
            t.isModeDark = t.modeDark;
        },
    },
    methods: {
        getList(noLoad){
            let t = this;
            let urlService = t.apis.get(0); // getCat
            if(noLoad==undefined){ t.isLoading = true; }
            // @ts-ignore
            window.master.post(urlService, {
                user_id: window.master_client,
                org_id: window.localorgdata,
                rows: t.pagRows,
                filter_group: t.filter_group,
                filter_name: t.searchCategory,
                filter_status: t.filter_status,
                ordenKey: t.ordenKey,
                ordenVal: t.ordenVal,
            }, {
                headers: {
                    common: {
                        // @ts-ignore
                        Authorization: 'Bearer ' + window.localtoken_M
                    },
                },
                onUploadProgress: (progressEvent) => {
                    let scanPer = Math.floor(
                        (progressEvent.loaded*100 / progressEvent.total)
                    );
                    if(scanPer < 99){ t.apiProgess = scanPer; }
                }
            })
            .then((response) => {
                t.apiProgess = 100;
                t.urlMedia = response.data.path.url;
                t.path_base = response.data.path.path_base;
                if(response.data.list.total > 0){
                    t.listCat = response.data.list.data;
                    t.categoryActive = t.listCat[0];
                    t.sectionActive = t.listCat[0].id;
                }
                if(response.data.currency){
                    t.currency = response.data.currency.meta_value;
                }
                t.isLoading = false;
            }).catch((error) => {
                console.log(error);
                t.apiProgess = 0;
                t.isLoading = false;
            });
        },
        showSection($event){
            let t = this;
            t.sectionActive = $event;
            setTimeout(() => { t.indicadorMenu(); }, 200);
        },
        indicadorMenu(){
            const menu = document.querySelector('.container_bStore_widget .nav-category');
            const indicador = document.querySelector('.container_bStore_widget #indicador');
            if(!menu || !indicador) return;
            let listNav = menu.querySelectorAll('ul.menu-categores li');
            if(listNav.length > 2){
                let itemActivo = menu.querySelector('ul.menu-categores li a.active');
                if(itemActivo){
                    let tamanoIndicador = itemActivo.offsetWidth;
                    indicador.style.width = tamanoIndicador + 'px';
                    let indexSeccionActiva = itemActivo.offsetLeft;
                    indicador.style.transform = `translateX(${indexSeccionActiva}px)`;
                    let leftScroll = menu.offsetWidth - (indexSeccionActiva + tamanoIndicador);
                    if(leftScroll < 0){
                        menu.scrollLeft = (leftScroll * -1) + 40;
                    } else if(leftScroll > 0){
                        menu.scrollLeft -= leftScroll;
                    }
                } else {
                    indicador.style.width = '0px';
                    indicador.style.transform = `translateX(0px)`;
                }
            }
        },
        changeCatActive(event){
            this.categoryActive = event;
        },
        menuLiOffsetWidth(){
            const mainNav = document.querySelector('.container_bStore_widget .main-nav-category');
            if(mainNav){
                const ulMenuCat = document.querySelector('.container_bStore_widget ul.menu-categores');
                if(ulMenuCat){
                    let navCat = 0;
                    ulMenuCat.querySelectorAll('li').forEach(li => { navCat += li.offsetWidth; });
                    if(navCat < mainNav.offsetWidth){
                        let liWidth = mainNav.offsetWidth / ulMenuCat.querySelectorAll('li').length;
                        if(liWidth > 0 && ((liWidth * ulMenuCat.querySelectorAll('li').length) >= mainNav.offsetWidth)){
                            ulMenuCat.querySelectorAll('li').forEach(li => {
                                li.style.flex = 'auto';
                                li.style.display = 'flex';
                                li.style.justifyContent = 'center';
                            });
                            ulMenuCat.style.width = '100%';
                            ulMenuCat.style.justifyContent = 'space-around';
                        }
                    }
                    this.indicadorMenu();
                }
            }
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
